import { js_utils } from "../utils/frfr-js-utils";
import JSDisplayValue from "./JSDisplayValue";


//
const _is_image_src = (src) => {
  // if (typeof src !== 'string') {
  if (typeof src !== 'string' || !src.trim()) {
    return false;
  }
  const trimmed = src.trim();
  const fileRegex = /\.(jpg|jpeg|png|webp|avif|gif|svg)$/i; // Provera za standardne ekstenzije fajlova
  // return fileRegex.test(trimmed) || dataUrlRegex.test(trimmed);
  if (fileRegex.test(trimmed)) {
    return true;
  } else {
    const dataUrlRegex = /^data:image\/(png|jpeg|webp|gif|svg\+xml);base64,/; // Provera za Base64 Data URL (npr. data:image/png;base64,...)
    if (dataUrlRegex.test(trimmed)) {
      return true;
    }
  }
  return false;
};

//
const isValidUrl = (str) => {
  try {
    let urlString = str.trim();
    if (urlString.startsWith('//')) {
      // Ako počinje sa //, privremeno dodajemo protokol da bi parser radio
      urlString = 'http:' + urlString;
    }
    // Konstruktor će baciti grešku ako string nije validan URL
    const url = new URL(urlString);
    // Proveravamo da li protokol podržava web (obično http ili https)
    return url.protocol === "http:" || url.protocol === "https:";
  } catch (err) {
    // Ako baci grešku, string nije validan URL
    return false;
  }
};


//
const RapidoziDisplayValueAsLink = (props) => {
  // const href = props.href;
  const href = props.val;
  /*
  let style = {};
  // if (props.style) {
  if (js_utils.is_object(props.style)) {
    style = props.style;
  }
  */
  let extraClass = '';
  if (typeof props.extraClass === 'string') {
    extraClass = props.extraClass;
  }
  //
  return (
    <a className={"rapidozi-display-value rapidozi-display-value--as-link " + extraClass} target="_blank" rel="noopener noreferrer" href={href}>{href}</a>
  );
};


//
const RapidoziDisplayValueAsImage = (props) => {
  // const src = props.src;
  const src = props.val;
  const alt = props.alt; // TODO
  const avatar = props.avatar; // TODO
  let style = {};
  // if (props.style) {
  if (js_utils.is_object(props.style)) {
    style = props.style;
  }
  let extraClass = '';
  if (typeof props.extraClass === 'string') {
    extraClass = props.extraClass;
  }
  //
  return (
    <figure className={"rapidozi-display-value rapidozi-display-value--as-image " + extraClass}>
      <img className="rapidozi-display-value__img" src={src} style={style} />
      <figcaption>{src}</figcaption>
    </figure>
  );
};


// DEFAULT COMPONENT
// RapidoziDisplayValueSmart
const RapidoziDisplayValue = (props) => {
  const {
    val,
    smart,
    isInsideResizableCell
  } = props;
  //
  let jsx = null;
  if (typeof val === 'string') {
    if (_is_image_src(val)) {
      jsx = (
        <RapidoziDisplayValueAsImage val={val} src={val} />
      );
    } else if (isValidUrl(val)) { // CASE url
      jsx = (
        <RapidoziDisplayValueAsLink val={val} href={val} />
      );
    } else if (val.length > 20) { // CASE string long
      jsx = (
        <JSDisplayValue val={val} />
      );
    } else { // CASE any other string
      jsx = (
        <JSDisplayValue val={val} />
      );
    }
  } else {
    jsx = (
      <JSDisplayValue val={val} />
    );
  }
  //
  return (
    <>{jsx}</>
  );
};

export default RapidoziDisplayValue;